import {useEffect} from 'react'
import {useParams} from 'react-router-dom'
import {useUrlQueryParams} from 'swayok-react-mdb-ui-kit/helpers/useUrlQueryParams'
import {NavigationService} from 'swayok-react-mdb-ui-kit/services/NavigationService'
import type {
    AnyObject,
    AnyRouteParams,
} from 'swayok-react-mdb-ui-kit/types/Common'

interface Props {
    to: string
    passUrlParams?: boolean
    passUrlQueryParams?: boolean
}

// Перенаправление на другую страницу.
// Замена глючному <Navigate to=""/>, который при использовании в
// <Route element={...}/> устраивает рекурсивное перенаправление.
export function RedirectRoute(props: Props) {

    const {
        to,
        passUrlParams,
        passUrlQueryParams,
    } = props

    const params = useParams<AnyRouteParams>()
    const {urlQueryData} = useUrlQueryParams<AnyObject<string>>()

    useEffect(() => {
        NavigationService.replace(
            to,
            passUrlParams ? params : undefined,
            passUrlQueryParams ? urlQueryData as AnyObject<string> : undefined
        )
    }, [])

    return (
        <div />
    )
}
